
export const setPayload = ({
  originState,
  destState,
  equipmentType,
  daysFromToday,
  manageStatus,
  movementNumber
}) => {
  const payload = {}

  if (movementNumber) {
    payload.orderNumber = movementNumber
    return payload
  }

  if (originState) {
    payload.originState = originState?.state_id
  }

  if (destState) {
    payload.destState = destState?.state_id
  }

  if (equipmentType) {
    payload.equipmentType = equipmentType?.equipment_code
  }

  if (daysFromToday) {
    payload.daysFromToday = daysFromToday?.value
  }

  if (manageStatus.length) {
    payload.manageStatus = manageStatus.length >= 2 ? 'all' : manageStatus[0]
  }

  return payload
}
